import { Button } from '@material-ui/core';
import en from '../../../../lang/en-us';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getPortfolio } from '../../../../redux-store/actions/portfolio';
import { RootStateType } from '../../../../redux-store/reducers';
import { sendPhoneOTP as sendOtp } from '../../../../redux-store/actions/nct';
import {
    getPortfoliosFilteredData,
    notLockedFolio,
    portfoliosByMinorStatus,
    portfoliosByModeOfHolding,
    portfoliosByTransactionResource,
} from '../../portfolios/utils';
import { NoteModals } from '../../../../lib/NoteModals';
import { TableColumn, TableWithCollapse } from '../../../../lib/DataTable';
import { UPDATE_EMAIL, OTP_ACTIONS, REGISTER_WITH_EMAIL } from '../../../../utils/constants';
import NoFoliosFound from './../NoFoliosFound';
import { useTableWithCollapse } from '../../../../lib/DataTable/customHooks';
import { ActionHeader, FaqLink } from '../index';
import { nextScreen } from '../ChangeMobile/flow';
import { NFT_TRXN_TYPE_MAP } from '../../commercial/utils';
import { PanSeedCheckNew } from '../../../common/PanSeedCheckNew';

const { dashboard } = en;

const columns: TableColumn[] = [
    { field: 'id', headerName: 'Folio' },
    { field: 'amcName', headerName: 'Fund House', width: 300 },
    { field: 'investorName', headerName: 'Primary Holder', width: 250 },
    { field: 'email', headerName: 'Email Address', width: 200 },
];
export interface RowInfoType {
    id: string | number;
    amcName: string;
    folio?: string;
    investorName?: string;
    taxStatus?: string;
    email?: string;
    amc?: string;
    schemeNames?: string[];
    mobile?: string;
    assetType?: string[];
    isDisabled?: boolean;
}

function ChangeEmailList(props: any) {
    const { enteredEmail: email } = props.location.state || {};
    const [loading, setLoading] = useState<boolean>(false);
    const [rowData, setRowData] = useState<RowInfoType[]>([]);
    const { tableRows, tableColumns, selectedRows, setSelectedRows } = useTableWithCollapse<
        RowInfoType[]
    >({ rows: rowData, columns, loading });
    const [show, setShow] = useState<boolean>(false);

    const handleSubmit = async () => {
        try {
            const goTo = nextScreen(props.match.path, 'email');
            const { pan = '', pekrn = '', mobile = '' } = props;
            const foliosToUpdate = selectedRows.filter((fund) => fund.email !== email);
            // const action = emailRegisteredUser()
            //     ? OTP_ACTIONS.changeEmail
            //     : OTP_ACTIONS.changeMobile;
            if (foliosToUpdate.length) {
                let res = await props.sendOtp({
                    pan,
                    pekrn,
                    action: OTP_ACTIONS.changeEmail,
                });
                props.history.replace(goTo, {
                    foliosToUpdate: selectedRows.filter((fund) => fund.email !== email),
                    ...(props?.location?.state || {}),
                    action: OTP_ACTIONS.changeEmail,
                    ...(res || {}).body,
                });
            }
        } catch (err: any) {
            alert(err.message);
        }
    };

    useEffect(() => {
        if (!(props.email || email)) {
            props.history.replace('/');
        }
    }, []);

    useEffect(() => {
        async function fetchPortfolio() {
            try {
                setLoading(true);
                const { pan = '', pekrn = '', mobile = '', reqId = '' } = props;
                await props.getPortfolio({
                    pan,
                    pekrn,
                    mobile,
                    reqId,
                });
                setLoading(false);
            } catch (err: any) {
                alert(err.message);
                setLoading(false);
            }
        }
        fetchPortfolio();
    }, []);

    useEffect(() => {
        const { portfolios = {} } = props;
        const { data: folioList = [] } = portfolios;
        const filters: Function[] = [
            portfoliosByTransactionResource,
            portfoliosByModeOfHolding,
            portfoliosByMinorStatus,
            notLockedFolio,
        ];

        let data: RowInfoType[] = getPortfoliosFilteredData(folioList, filters);
        const { activeFunds = [], disabledFunds = [] } = data.reduce((prev: any, curr: any) => {
            if (curr.email !== email) {
                return {
                    ...prev,
                    activeFunds: [...(prev.activeFunds ?? []), curr],
                };
            }
            return {
                ...prev,
                disabledFunds: [...(prev.disabledFunds ?? []), { ...curr, isDisabled: true }],
            };
        }, []);
        setRowData([...activeFunds, ...disabledFunds]);
        setSelectedRows([...activeFunds, ...disabledFunds]);
    }, [props.portfolios]);

    const [callPanSeed, setCallPanSeed] = useState(false);

    const resetTrigger = () => {
        setCallPanSeed(false);
    };

    return (
        <div className="curved-bg">
            <PanSeedCheckNew
                foliosArray={selectedRows}
                callBackFn={() => {
                    props.userRegisteredWith === REGISTER_WITH_EMAIL
                        ? setShow(!show)
                        : handleSubmit();
                }}
                trxnType={NFT_TRXN_TYPE_MAP.changeEmail}
                triggerCheck={callPanSeed}
                resetTrigger={resetTrigger}
                goBack={false}
            />
            <ActionHeader header={dashboard.changeEmail.changeEmailHeading} />
            <div className="curved-bg-content curved-bg-table-outer">
                <div className="curved-bg-content-table">
                    <h5> {dashboard.changeEmail.List.emailNote}</h5>
                    <div className="curved-table-content">
                        <div className="curved-table-content-bottom" style={{ width: '100%' }}>
                            {!rowData.length && !loading ? (
                                <NoFoliosFound
                                    extraClass="consolidation-error"
                                    icon="error-red"
                                    info={'No Portfolios found'}
                                />
                            ) : (
                                <TableWithCollapse
                                    setSelectedRows={setSelectedRows}
                                    selectedRows={selectedRows}
                                    rows={tableRows}
                                    columns={tableColumns}
                                    isRowSelectable={() => false}
                                    toolTipTextGetter={({ row }) =>
                                        row.isDisabled
                                            ? dashboard.changeEmail.toolTipWithSameEmailId
                                            : dashboard.changeEmail.List.toolTip
                                    }
                                    checkBoxEnabled
                                    toolTipEnabled
                                    isCheckBoxSelectable={false}
                                />
                            )}
                        </div>
                    </div>
                    <FaqLink section={UPDATE_EMAIL} history={props.history} />
                </div>
                {!!tableRows.length && (
                    <div className="curved-bg-content-inner-bottom">
                        <div className="table-submit">
                            <Button
                                disabled={
                                    loading ||
                                    !selectedRows.filter((fund) => fund.email !== email).length
                                }
                                onClick={() => setCallPanSeed(true)}
                                className="customBtn"
                            >
                                {dashboard.changeEmail.List.buttonText}
                            </Button>
                        </div>
                    </div>
                )}
                <NoteModals
                    showModal={show}
                    heading={dashboard.noteModals.otpAuth.heading}
                    // mobileOrEmail={maskMobileNumber(props.mobile)}
                    info={`${dashboard.noteModals.otpAuth.subHeadingMail} ${
                        email || props.email
                    }. ${dashboard.noteModals.otpAuth.confirmText}`}
                    proceedBtn={dashboard.noteModals.otpModal.proceedText}
                    cancelBtn={dashboard.noteModals.otpModal.cancelText}
                    onProceed={handleSubmit}
                    onCancel={() =>
                        props.history.push('change-email-document', {
                            foliosToUpdate: selectedRows.filter((fund) => fund.email !== email),
                        })
                    }
                />
            </div>
        </div>
    );
}

export default connect(
    ({ authReducer, portfolio }: RootStateType) => ({
        ...authReducer,
        ...portfolio,
    }),
    {
        getPortfolio,
        sendOtp,
    },
)(ChangeEmailList);
